<div class="flex flex-row items-center" *ngIf="authService?.isSignedIn$ | async">
  <!-- @todo(soham): is a notifications count required? If yes, remove hardcoded '15' and fetch from API. If not, delete this icon. -->
  <div class="flex mr-4"><mat-icon matBadge="15" matBadgeColor="warn" aria-hidden="false">notifications</mat-icon></div>
  <button mat-fab class="profile-icon mx-3" aria-label="Profile" [matMenuTriggerFor]="menu">
    <mat-icon>person</mat-icon>
  </button>
  <mat-menu #menu="matMenu" xPosition="before">
    <div class="main-menu">
      <div class="mb-4">
        <div class="flex flex-row items-center">
          <img class="profile-img" src="assets/images/profile-icon.png" alt="Profile Image" />
          <span class="ml-4" *ngIf="user?.attributes">{{ user?.attributes['email'] }}</span>
        </div>
      </div>
      <div>
        <button mat-menu-item (click)="toggleTheme()">
          <mat-icon color="primary">{{ currentTheme == 'dark' ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
          Dark Theme
        </button>
      </div>
      <div>
        <button mat-menu-item (click)="signOut()">
          <mat-icon>logout</mat-icon>
          Sign Out
        </button>
      </div>
    </div>
  </mat-menu>
</div>
<div *ngIf="(authService?.isSignedIn$ | async) === false">
  <a class="flex items-center decoration-none text-white" role="button" routerLink="auth/signin"> Sign In </a>
</div>
